<div id="academy-courses" class="page-layout simple">

    <!-- HEADER -->
    <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

        <div class="hero-text">
            <h1 *ngIf="typeTitle==0">
            </h1>
            <h1 *ngIf="typeTitle==1">
              {{'WIZARD.LANDING.PRODUCTO.PULSE.ADMINTITULO' | translate}}
            </h1>
            <h1 *ngIf="typeTitle==2">
              {{'WIZARD.LANDING.PRODUCTO.FOCUS_1.ADMINTITULO' | translate}}
            </h1>
        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div fxLayout="column" fxLayoutAlign="center">
            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" >

                <ng-container *ngIf="cargando">
                  <div fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch"  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <div fxLayout="column" fxLayoutAlign="space-between center" >
                      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                      <!-- <h2 *ngIf="!productoFocus">{{'WIZARD.LANDING.PRODUCTO.PULSE.CARGANDO_PULSE' | translate}} </h2>
                      <h2 *ngIf="productoFocus">{{'WIZARD.LANDING.PRODUCTO.FOCUS_1.CARGANDO_FOCUS' | translate}}</h2> -->
                    </div>
                  </div>
                </ng-container>
<ng-container *ngIf="!pulse3Navigation && !cargando">
  <ng-container *ngFor="let producto of aniosPulsecheck">
    <ng-container *ngIf="producto.fecha == anioseleccionado ">
      <ng-container *ngFor="let productoPulsos of producto.datos">

        <div  class="course" fxFlex="100" fxFlex.gt-sm="33">
          <!-- <div class="" *ngIF="producto.fecha = anioseleccionado"> -->
            <div class="cursoCard" fxFlex="100">
              <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                <div class="header primary " fxLayout="row" fxLayoutAlign="center center">
                  <div class="category" fxFlex>{{'WIZARD.LANDING.PRODUCTO.PULSE.PULSOS' | translate}}</div>
                  <div * class="length" fxLayout="row" fxLayoutAlign="end center">
                    <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                  </div>
                </div>

                <div class="content  p-20 m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                  <div class="h1">{{'WIZARD.LANDING.PRODUCTO.PULSE.PRODU' | translate}} {{productoPulsos.numero}} </div>
                  <div class="h1"> {{productoPulsos.fechaLanzamiento |date:"fullDate":'':idiomaActual}}</div>
                  <!-- <div class="updated">{{'WIZARD.LANDING.DONE' | translate}}{{producto.date}}</div> -->
                </div>

                <ng-container *ngIf="productoPulsos.btnPortalConteos && productoPulsos.encuestaActiva==1 ">
                  <div class="" fxLayout="column" fxLayoutAlign="center center">
                    <button mat-raised-button class="mb-20 accent" [routerLink]="'/portalControl/'" (click)="obtenerProductoId(productoPulsos.idPulseCheck,productoPulsos.fechaPulse)">
                      {{'CIERRE.CIERRE.BCONTEOS' | translate}}
                      <mat-icon class="ml-20">poll</mat-icon>
                    </button>
                  </div>
                </ng-container>

                <div class="footer" fxLayout="row" fxLayoutAlign="center center">

                    <button mat-button class="accent rndBt" fxFlex="100"
                    (click)="navigateTo(urlPulseNavigation,productoPulsos.idPulseCheck);">{{'WIZARD.LANDING.PRODUCTO.PULSE.ENTRAR' | translate}}</button>

                </div>



              </div>
            </div>
          </div>

          <!-- </div> -->
        </ng-container>
      </ng-container>
    </ng-container>

</ng-container>

<ng-container *ngIf="pulse3Navigation && !cargando">
<ng-container *ngIf="!productoFocus">
  <div class="mt-20" fxLayout="row" fxLayoutAlign="end center" fxFlex="100" *ngIf="productoFocus">
    <div class="" fxLayout="row" fxLayoutAlign="end center" >
    <h2 class="pr-20">{{'LANDINFOCUS.WIZARD.CREARENC' | translate}}</h2>
    <button mat-fab color="primary" aria-label="agregaPreg" (click)="nombreEncuesta();" >
    <!-- <button mat-fab color="primary" aria-label="agregaPreg" (click)="openDialogCreaEncues();" > -->
    <mat-icon>add</mat-icon>
  </button>
  </div>
  </div>
  <ng-container *ngFor="let producto of aniosPulsecheck">
    <ng-container *ngIf="producto.fecha == anioseleccionado ">
      <ng-container *ngFor="let productoPulsos of producto.datos">

        <div  class="course" fxFlex="100" fxFlex.gt-sm="33">
          <!-- <div class="" *ngIF="producto.fecha = anioseleccionado"> -->
            <div class="cursoCard" fxFlex="100">
              <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                  <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                  <div class="category" fxFlex >{{'WIZARD.LANDING.PRODUCTO.PULSE.PULSOS' | translate}}</div>
                  <div * class="length" fxLayout="row" fxLayoutAlign="end center">
                    <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                  </div>
                </div>

                <div class="content  p-20 m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                  <div class="h1" >{{'WIZARD.LANDING.PRODUCTO.PULSE.PRODU' | translate}} {{productoPulsos.numPulse+1}} </div>
                  <div class="h1" > {{productoPulsos.fechaLanzamiento |date:"fullDate":'':idiomaActual}}</div>
                  <!-- <div class="updated">{{'WIZARD.LANDING.DONE' | translate}}{{producto.date}}</div> -->
                </div>

                <ng-container *ngIf="productoPulsos.btnPortalConteos && productoPulsos.encuestaActiva==1 ">
                  <div class="" fxLayout="column" fxLayoutAlign="center center">
                    <button mat-raised-button class="mb-20 accent" [routerLink]="'/portalControl/'" (click)="obtenerProductoId(productoPulsos.idCertificar,productoPulsos.fechaCertificar)">
                      {{'CIERRE.CIERRE.BCONTEOS' | translate}}
                      <mat-icon class="ml-20">poll</mat-icon>
                    </button>
                  </div>
                </ng-container>

                <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                    <button mat-button class="accent rndBt" fxFlex="100"
                    (click)="navigatePulse3(urlPulseNavigation,productoPulsos.idCertificar,productoPulsos.modifUrlShort,productoPulsos.closeNotice,productoPulsos.selectNotice1,productoPulsos.selectNotice2);">{{'WIZARD.LANDING.PRODUCTO.PULSE.ENTRAR' | translate}}</button>
                </div>



              </div>
            </div>
          </div>

          <!-- </div> -->
        </ng-container>
      </ng-container>
  </ng-container>
</ng-container>

<ng-container *ngIf="productoFocus">
  <div class="" style="width:100%">
    <mat-tab-group  [(selectedIndex)]="tabSeleccionada"  mat-align-tabs="start">
      <mat-tab label="{{'WIZARD.LANDING.PRODUCTO.FOCUS_1.TAB_SUBIDA_COLB_FOC' | translate}}">
        <div fxLayout="row wrap" fxLayoutAlign="center" class="p-20">
          <ng-container *ngIf="cargando">
            <div fxLayout="column" fxLayoutAlign="space-between center" >
              <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
              <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
            </div>
          </ng-container>

          <ng-container *ngIf="!cargando">
            <ng-container *ngIf="stored">
              <div class="statusDiv" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <div class="roundEdg done mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                  <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.OK' | translate}}</h2>
                  <mat-icon class="ml-20 s-40">check_circle</mat-icon>
                </div>
              </div>

              <div class="mt-40" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <div class="mat-elevation-z3 p-20" fxFlex="40" fxLayout="column" fxLayoutAlign="space-between stretch">
                  <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_BD.TITULO' | translate}}</h2>
                  <mat-divider></mat-divider>
                  <div class="mt-20 mb-20">
                    <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_BD.NUMCOLABS' | translate}}</div>
                    <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{colabsEnBD | number:'.0'}}</div>
                  </div>
                  <mat-divider></mat-divider>
                  <div class="mt-20">
                    <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_BD.FECHA' | translate}}</div>
                    <!-- <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{fechaCarga |date:"fullDate":'':idiomaActual}}</div> -->
                    <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{fechaCarga|date:"d MMM y H:mm":offsetPipe:idiomaUtc}} ({{fechaCarga|date:'z':offsetPipe:idiomaActual}})</div>
                  </div>
                  <!-- <ng-container >
                    <mat-expansion-panel class="mb-20 accent-50" style="margin-top:15px">
                      <mat-expansion-panel-header>
                        <mat-panel-title style="font-weight:bold; padding-left:20px; text-align:center">
                          {{'CERTIFICAR.COLABORADORES.CARD_BD.TITULO_PRE' | translate}}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <mat-list >
                        <mat-list-item *ngFor="let histoGeneration of historyUpdateColaboration  let y = index">
                          <p class="" style="color:#C9CACD">{{y}}) {{histoGeneration.updatedAt |date:"d MMM y H:mm":offsetPipe:idiomaUtc}} ({{histoGeneration.updatedAt |date:'z':offsetPipe:idiomaActual}}) => {{histoGeneration.colaboradores}}   {{'CERTIFICAR.COLABORADORES.CARD_BD.TITULO_PRE_2' | translate}} </p>
                          <mat-divider></mat-divider>
                        </mat-list-item>

                      </mat-list>
                    </mat-expansion-panel>
                  </ng-container> -->
                </div>
                <div class="mat-elevation-z3 p-20" fxFlex="40" fxLayout="column" fxLayoutAlign="start stretch">
                  <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_BD.ACCIONES' | translate}}</h2>
                  <mat-divider></mat-divider>
                  <div class="mt-20" fxLayout="column" fxLayoutAlign="start center">
                    <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_BD.WANNADO' | translate}}</div>
                    <div class="mt-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch">
                      <!-- <button mat-raised-button class="mb-20 primary" (click)="descargaExcel()">
                        {{'CERTIFICAR.COLABORADORES.CARD_BD.BOTONES.DESCARGA' | translate}}
                        <mat-icon class="ml-20">cloud_download</mat-icon>
                      </button> -->
                      <button mat-raised-button class="mb-20 warn" (click)="borrarColaboradores()">
                        {{'CERTIFICAR.COLABORADORES.CARD_BD.BOTONES.ELIMINA' | translate}}
                        <mat-icon class="ml-20">delete_forever</mat-icon>
                      </button>
                      <button mat-raised-button class="mb-20 warn" (click)="verListaColaboradores()">
                        {{'CERTIFICAR.COLABORADORES.CARD_BD.BOTONES.VER' | translate}}
                        <mat-icon class="ml-20">people</mat-icon>
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="!stored">
              <div class="statusDiv">
                <div *ngIf="files.length == 0" class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                  <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.NOBD' | translate}}</h2>
                  <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
                <div *ngIf="files.length > 0 && errores.length > 0" class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                  <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.ERROR' | translate}}</h2>
                  <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
                <div *ngIf="files.length > 0 && errores.length == 0" class="roundEdg primary mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                  <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.PROCES' | translate}}</h2>
                  <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
              </div>

              <!-- formulario inicial -->
              <div *ngIf="!cargandoBD && files.length == 0" class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">

                <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
                [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_NOBD.TITULO' | translate}}</h2>
                <mat-divider></mat-divider>
                <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
                  <mat-icon class="s-30 mr-20">filter_1</mat-icon>
                  <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_NOBD.PASOS.1' | translate}}</b></div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center stretch" class="mb-20">
                  <a mat-raised-button class="primary" fxFlex="60" matTooltip="{{'CERTIFICAR.COLABORADORES.CARD_NOBD.TOOLTIP' | translate}}"
                  [href]="urlAssets + 'platform/plantillasBD/' + instituto + '/CollaboratorsListTemplate_' + idiomaActual + '.xlsm'" download (click)="ModalArchivo()">
                  {{'CERTIFICAR.COLABORADORES.CARD_NOBD.FILE' | translate}}
                  <mat-icon class="ml-20">save_alt</mat-icon>
                </a>
              </div>
              <mat-divider></mat-divider>
              <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
                <mat-icon class="s-30 mr-20">filter_2</mat-icon>
                <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_NOBD.PASOS.2' | translate}}</b></div>
              </div>
              <mat-divider></mat-divider>
              <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
                <mat-icon class="s-30 mr-20">filter_3</mat-icon>
                <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_NOBD.PASOS.3' | translate}}</b></div>
              </div>
              <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop
              (onFileDropped)="uploadFile($event)" *ngIf="totRows == 0 && !cargandoBD"
              [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
              <!-- <input hidden type="file" #fileInput (change)="onFileChange($event)" accept="application/vnd.ms-excel.sheet.macroEnabled.12, application/vnd.ms-excel.sheet.macroenabled.12"> -->
                <input hidden type="file" #fileInput (change)="analizarExcel($event)" accept="application/vnd.ms-excel.sheet.macroEnabled.12, application/vnd.ms-excel.sheet.macroenabled.12">
              <h1>{{'CERTIFICAR.COLABORADORES.UPLOAD' | translate}}</h1>
            </div>
          </div>

        </div>

        <!-- formulario cuando no hay errores -->
        <div *ngIf="!guardandoBD && arregloColaboradores.length > 0 && errores.length == 0" class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">

          <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
          *ngFor="let file of files;let i=index"  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_NOERR.TITULO' | translate}}</h2>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_NOERR.NUMCOLABS' | translate}}</div>
            <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{arregloColaboradores.length | number:'.0'}}</div>
          </div>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_NOERR.FILENAME' | translate}}</div>
            <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{ file }}</div>
          </div>
          <mat-divider></mat-divider>
          <div class="mt-20 h2 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_NOERR.GUARDAR' | translate}}</div>
          <div class="mt-20" fxLayout="row" fxLayoutAlign="space-between stretch">
            <button mat-raised-button class="warn" fxFlex="45" (click)="deleteAttachment(i,true)">
              {{'CERTIFICAR.COLABORADORES.CARD_NOERR.BOTONES.NO' | translate}}
            </button>
            <button mat-raised-button class="primary" fxFlex="45" (click)="guardarColaboradoresBD()">
              {{'CERTIFICAR.COLABORADORES.CARD_NOERR.BOTONES.SI' | translate}}
            </button>
          </div>
        </div>

      </div>

      <!-- formulario cuando hay errores -->
      <div *ngIf="errores.length > 0" class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">

        <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
        *ngFor="let file of files;let i=index" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.TITULO' | translate}}</h2>
        <mat-divider></mat-divider>
        <div fxLayout="row" fxLayoutAlign="space-between stretch">
          <div class="mt-20 mb-20" fxFlex="50">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.ROWS_OK' | translate}}</div>
            <div fxLayout="row" fxLayoutAlign="start center">
              <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{arregloColaboradores.length}}</div>
              <mat-icon class="s-50 ml-20">done</mat-icon>
            </div>
          </div>
          <div class="mt-20 mb-20" fxFlex="50">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.ROWS_NOTOK' | translate}}</div>
            <div fxLayout="row" fxLayoutAlign="start center">
              <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{errores.length}}</div>
              <mat-icon class="s-50 ml-20">close</mat-icon>
            </div>
            <div class="h4 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.MOREINFO' | translate}}</b></div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="mt-20 mb-20">
          <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.FILENAME' | translate}}</div>
          <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{ file }}</div>
        </div>
        <mat-divider></mat-divider>
        <div class="mt-20 h2 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.GUARDAR' | translate}}</div>
        <button mat-raised-button class="warn mt-20" (click)="deleteAttachment(i,true)">
          {{'CERTIFICAR.COLABORADORES.CARD_ERRFND.DELETE' | translate}}
        </button>
      </div>

    </div>

    <!-- listado de errores -->
    <div *ngIf="errores.length > 0" class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">

      <div class="mat-elevation-z3 p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between stretch"
      [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
      <div fxLayout="row" fxLayoutAlign="space-between stretch">
        <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.TITULO.1' | translate}}{{errores.length}}</h2>
        <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.TITULO.2' | translate}}{{erroresTotales}}</h2>
      </div>
      <mat-divider></mat-divider>
      <div class="mt-20 mb-20">

        <mat-accordion>

          <ng-container *ngFor="let error of errores; index as i;">
            <mat-expansion-panel class="mb-20">

              <mat-expansion-panel-header class="accent-50">
                <mat-panel-title>
                  <b>{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.INFO.ROW' | translate}}{{error.numeroFila}}</b>
                  <b class="ml-20">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.INFO.ERRNUM' | translate}}{{error.listaErrores.length}}</b>
                </mat-panel-title>
                <mat-panel-description>
                  {{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.INFO.SHOW' | translate}}
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div *ngFor="let detalleError of error.listaErrores" class="mat-elevation-z3 p-20 mt-20 mb-20" fxLayout="column" fxLayoutAlign="space-between stretch">

                <div fxLayout="row" fxLayoutAlign="space-between stretch">
                  <div fxFlex="50" fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="">
                      <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.TIPO' | translate}}</div>
                      <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.ERRORES.'+detalleError.tipoError | translate}}</div>
                    </div>
                    <button mat-icon-button color="primary" aria-label="aiuda" class="mr-20" (click)="infoError(detalleError.tipoError)">
                      <mat-icon class="s-40">help</mat-icon>
                    </button>
                  </div>
                  <div fxFlex="50">
                    <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.COLUMNA' | translate}}</div>
                    <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{detalleError.columna}}</div>
                  </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="start stretch" class="mt-20">
                  <!-- <div fxFlex="50">
                    <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.DESCR' | translate}}</div>
                    <div class="h3 secondary-text pr-20"><b>{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DESCRIPCION.'+detalleError.tipoError | translate}}</b></div>
                  </div>
                  <div fxFlex="50">
                    <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.DATO' | translate}}</div>
                    <div class="datoErroneo">{{detalleError.dato}}</div>
                  </div> -->
                  <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.DATO' | translate}}</div>
                  <table fxFlex="100" class="tablaError mt-8">
                    <tr>
                      <td width="10%" class="esi"></td>
                      <td width="90%" class="esd">{{detalleError.numeroColumna}}</td>
                    </tr>
                    <!-- <tr>
                      <td width="10%" class="cizq"></td>
                      <td width="90%" class="cnme">{{detalleError.columna}}</td>
                    </tr> -->
                    <tr>
                      <td class="eii">{{error.numeroFila}}</td>
                      <td class="datoErroneo">{{detalleError.dato}}</td>
                    </tr>
                  </table>
                </div>

              </div>

            </mat-expansion-panel>
          </ng-container>


        </mat-accordion>

      </div>
    </div>

  </div>

  <!-- pantalla "cargando" y "guardando" -->
  <div class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">
    <!--- cargando excel en front --->
    <div *ngIf="cargandoBD" class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
    [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
    <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.CARGA.TITULO' | translate}}</h2>
    <mat-divider></mat-divider>
    <div class="mt-20 mb-20">
      <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.CARGA.INFO' | translate}}</div>
      <mat-progress-bar mode="indeterminate" class="mt-20"></mat-progress-bar>
    </div>
  </div>
  <!--- guardando registros en back --->
  <div *ngIf="guardandoBD" class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
  <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.GUARDA.TITULO' | translate}}</h2>
  <mat-divider></mat-divider>
  <div class="mt-20 mb-20">
    <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.GUARDA.INFO' | translate}}</div>
    <mat-progress-bar mode="indeterminate" class="mt-20"></mat-progress-bar>
  </div>
</div>
</div>

</ng-container>
</ng-container>
</div>
</mat-tab>
<mat-tab label="{{'WIZARD.LANDING.PRODUCTO.FOCUS_1.TAB_PROC_FOC' | translate}}" fxLayout="row wrap">
  <div class="mt-20" fxLayout="row" fxLayoutAlign="end center" fxFlex="100" *ngIf="productoFocus">
    <div class="" fxLayout="row" fxLayoutAlign="end center" >
      <h2 class="pr-20">{{'LANDINFOCUS.WIZARD.CREARENC' | translate}}</h2>
      <!-- <button mat-fab color="primary" aria-label="agregaPreg" (click)="nombreEncuesta();" > -->
      <button mat-fab color="primary" aria-label="agregaPreg" (click)="openDialogCreaEncues();" >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
  <div class="" fxLayout="row wrap">
    <ng-container *ngFor="let producto of aniosPulsecheck">
      <ng-container *ngIf="producto.fecha == anioseleccionado ">
        <ng-container *ngFor="let productoPulsos of producto.datos">

          <div class="course" fxFlex="100" fxFlex.gt-sm="33" fxLayout="row wrap">
            <!-- <div class="" *ngIF="producto.fecha = anioseleccionado"> -->
              <div class="cursoCard" fxFlex="100">
                <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                  <div class="header primary " fxLayout="row" fxLayoutAlign="center center">
                    <div class="category" fxFlex *ngIf="productoFocus">{{'LANDINFOCUS.ENCUESTAS.TITULO' | translate}}</div>
                    <mat-icon color="white" (click)="eliminarEncuesta(productoPulsos.idCertificar);">delete_forever</mat-icon>
                    <div * class="length" fxLayout="row" fxLayoutAlign="end center">
                      <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                    </div>
                  </div>

                  <div class="content  p-20 m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                    <div class="h1" >{{productoPulsos.nameSurvey}}</div>
                  </div>

                  <ng-container *ngIf="productoPulsos.btnPortalConteos && productoPulsos.encuestaActiva==1 ">
                    <div class="" fxLayout="column" fxLayoutAlign="center center">
                      <button mat-raised-button class="mb-20 accent" [routerLink]="'/portalControl/'" (click)="obtenerProductoId(productoPulsos.idCertificar,productoPulsos.fechaCertificar)">
                        {{'CIERRE.CIERRE.BCONTEOS' | translate}}
                        <mat-icon class="ml-20">poll</mat-icon>
                      </button>
                    </div>
                  </ng-container>

                  <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                    <button mat-button class="accent rndBt" fxFlex="100"
                    (click)="navigateFocus3(urlPulseNavigation,productoPulsos.idCertificar,productoPulsos.modifUrlShort,productoPulsos.closeNotice,productoPulsos.selectNotice1,productoPulsos.selectNotice2);">{{'WIZARD.LANDING.PRODUCTO.PULSE.ENTRAR' | translate}}</button>
                  </div>



                </div>
              </div>
            </div>

            <!-- </div> -->
          </ng-container>
        </ng-container>
      </ng-container>

    </div>


  </mat-tab>
  <mat-tab *ngIf="resultados" label="{{'LANDINFOCUS.LISTA.TAB' | translate}}">
    <div fxLayout="column" fxLayoutAlign="start stretch">
      <div fxLayout="row" fxLayoutAlign="space-between center" class="p-20">
        <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="50">
          <p><em>{{'LANDINFOCUS.LISTA.BUSCAR.INFO' | translate}}</em></p>
          <mat-form-field appearance="outline">
            <mat-label>{{'LANDINFOCUS.LISTA.BUSCAR.PLACEHOLDER' | translate}}</mat-label>
            <input matInput (keyup)="buscaColaborador($event.target.value)">
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <h3>{{'LANDINFOCUS.LISTA.AGREGAR.BOTON' | translate}}</h3>
          <button mat-mini-fab color="primary" (click)="agregarColaborador()" class="ml-10" matTooltip="{{'LANDINFOCUS.LISTA.TOOLTIPS.AGREGAR' | translate}}" [matTooltipPosition]="'before'">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
      <ng-container *ngIf="resultados">
        <ng-container *ngIf="resultados.filteredData.length > 0">
          <table mat-table [dataSource]="resultados">

            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef>{{'LANDINFOCUS.LISTA.TABLA.COLUMNAS.NOMBRE' | translate}}</th>
              <td mat-cell *matCellDef="let colaborador; let i = index;">
                {{colaborador.fullName}}
              </td>
            </ng-container>

            <ng-container matColumnDef="correo">
              <th mat-header-cell *matHeaderCellDef>{{'LANDINFOCUS.LISTA.TABLA.COLUMNAS.EMAIL' | translate}}</th>
              <td mat-cell *matCellDef="let colaborador; let i = index;">
                {{colaborador.email}}
              </td>
            </ng-container>

            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>{{'LANDINFOCUS.LISTA.TABLA.COLUMNAS.ACCIONES' | translate}}</th>
              <td mat-cell *matCellDef="let colaborador; let i = index;">
                <button color="primary" mat-mini-fab matTooltip="Editar colaborador" [matTooltipPosition]="'before'" (click)="editarColaborador(colaborador)">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnasResultado"></tr>
            <tr mat-row *matRowDef="let row; columns: columnasResultado;"></tr>
          </table>
          <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
        </ng-container>
      </ng-container>
    </div>

  </mat-tab>
</mat-tab-group>

  </div>
</ng-container>
</ng-container>

            </div>
            <!-- / CONTENT -->

        </div>
